import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23f4f324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "token-icon" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "content-collapse" }
const _hoisted_4 = { class: "flex flex-center h-full" }

import { computed, ref } from 'vue';
import { Token } from '@/sdk/entities/token';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenCollapse',
  props: {
    token: null
  },
  setup(__props: any) {

const props = __props as {
  token: Token;
}



const isCollapsed = ref(true);
const imageSrc = computed(() => props.token.tokenIconUrl || '/images/tokens/no-icon.svg');
const isLoadError = e => (e.target.src = '/images/tokens/no-icon.svg');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["token-panel-collapse clickable", { active: !isCollapsed.value }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click'))),
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (isCollapsed.value = false)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isCollapsed.value = true))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(imageSrc),
        alt: __props.token.symbol,
        onError: _cache[0] || (_cache[0] = ($event: any) => (isLoadError($event)))
      }, null, 40, _hoisted_2)
    ]),
    _createVNode(_Transition, { name: "content-collapse" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.token.unwrapWETH().symbol), 1)
        ], 512), [
          [_vShow, !isCollapsed.value]
        ])
      ]),
      _: 1
    })
  ], 34))
}
}

})